import { render } from "./PedToken.vue?vue&type=template&id=2946396e&scoped=true"
import script from "./PedToken.vue?vue&type=script&lang=js"
export * from "./PedToken.vue?vue&type=script&lang=js"

import "./PedToken.vue?vue&type=style&index=0&id=2946396e&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2946396e"]])

export default __exports__